import * as React from "react";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
const menuItems = [{
  title: "Al Pastor Street Tacos",
  description: "Marinated pork, pineapple, cilantro, onion, and salsa verde on corn tortillas.",
  price: "$12.00",
  isSpecial: true
}, {
  title: "Birria Quesatacos",
  description: "Slow-cooked beef, melted cheese, consommé for dipping, and fresh lime.",
  price: "$14.50",
  isSpecial: true
}, {
  title: "Street Corn (Elote)",
  description: "Grilled corn, chipotle mayo, cotija cheese, tajin, and fresh cilantro.",
  price: "$6.00",
  isSpecial: false
}, {
  title: "Loaded Nacho Fries",
  description: "Crispy fries topped with queso, jalapeños, pico de gallo, and crema.",
  price: "$9.00",
  isSpecial: false
}, {
  title: "Agua Fresca del Dia",
  description: "Refreshing seasonal fruit water made fresh daily. Ask for today's flavor.",
  price: "$4.50",
  isSpecial: false
}];
export default function TacosSidesSips() {
  return <section data-section-id="255695" id="tacos-sides-sips" className="bg-background text-foreground py-16 md:py-24 px-4 md:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="mb-12">
          <h2 className="font-default text-4xl md:text-6xl font-bold uppercase tracking-tighter text-foreground">
            Tacos, Sides & Sips
          </h2>
          <p className="font-mono text-lg mt-4 text-primary font-medium uppercase tracking-wider">
            Street food soul. Rolling fresh daily.
          </p>
        </div>

        <div className="flex flex-col">
          <Separator className="bg-primary h-[8px]" />
          
          {menuItems.map((item, i) => <div key={i} data-index={i} className="flex flex-col pt-6 pb-2 group">
              <div className="flex flex-row justify-between items-baseline gap-4 mb-2">
                <div className="flex flex-wrap items-center gap-3">
                  <h3 className="font-default text-2xl md:text-3xl font-bold uppercase tracking-tight text-foreground group-hover:text-primary transition-colors">
                    {item.title}
                  </h3>
                  {item.isSpecial && <Badge variant="secondary" className="bg-primary text-primary-foreground hover:bg-primary border-transparent rounded-md font-mono text-[10px] px-2 py-0.5 tracking-widest uppercase">
                      Spicy
                    </Badge>}
                </div>
                <span className="font-mono text-xl md:text-2xl font-bold text-primary whitespace-nowrap">
                  {item.price}
                </span>
              </div>
              
              <p className="font-default text-xs md:text-[12px] text-muted-foreground leading-relaxed max-w-[85%] mb-4 uppercase tracking-wide">
                {item.description}
              </p>
              
              <Separator className="bg-border opacity-20" />
            </div>)}
        </div>
      </div>
    </section>;
}